import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    items: [],
    pagination: {
      sortDesc: [false],
      page: 1,
      sortBy: ['dispatchID'],
      itemsPerPage: 25,
      totalItems: 0,
    },
    totalItems: 0,
    filters: {
      search: null,
      status: 'active',
      type: null,
      isAPDevice: null,
    },
  },
  actions,
  mutations,
  getters: {},
};
